import { Component, OnInit, Input, ElementRef, Renderer2, EventEmitter, Output } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-layout-change-theme',
    templateUrl: './change-theme.component.html',
    styleUrls: ['./change-theme.component.css']
})
export class LayoutChangeThemeComponent implements OnInit {

    model: any = {};

    @Input() isDarkTheme: boolean;
    @Output() changedDarkTheme = new EventEmitter<boolean>();

    ngOnInit() {
        this.model.isLightTheme = !this.isDarkTheme;
    }

    toggleTheme() {
        this.changedDarkTheme.emit(!this.model.isLightTheme);
    }

}
